import { CallEvent } from '@modules/SoftPhoneModule/types';
import TasksModule from '@modules/TasksModule';
import { findStlTaskForCall } from './findStlTaskForCall';

/**
 * Handles phone.call.answered for STL tasks.
 * Sets `hasCallConnected` when the remote party answers, which enables
 * the "Book Job" button in the UI.
 */
function handleStlCallAnswered(event: CallEvent) {
  if (!event.originating) return;

  const stlTask = findStlTaskForCall(event.remoteIdentity);
  if (!stlTask) return;

  TasksModule.setTaskAttribute(stlTask.id, 'hasCallConnected', true);
}

export default handleStlCallAnswered;
